const languages = {
  'es_ES': {
    isoCode: 'es_ES', // required!
    empty: '',
    language: 'Idioma',
    ca_ES: 'Catalán',
    es_ES: 'Español',
    en_GB: 'Inglés',
    welcomehombre: 'Bienvenido {name}',
    welcomemujer: 'Bienvenida {name}',
    closeSession: 'Cerrar sesión',
    close: 'cerrar',
    username: 'Usuario',
    password: 'Contraseña',
    forgotUsername: '¿Olvidó su usuario?',
    forgotPassword: '¿Olvidó su contraseña?',
    activeSession: 'Mantenga la sesión activa',
    enter: 'entrar',
    rememberPassword: 'renovar contraseña',
    rememberUser: 'Introduce tu usuario y te enviaremos un email para renovar tu contraseña',
    checkRememberCode: 'Valida el código',
    checkRememberPassword: 'Guardar nueva contraseña',
    newPasword: 'Nueva contraseña',
    repeatPassword: 'Repite la contraseña',
    allRightsReserved: '© CCOO de Catalunya',
    registeredTrademark: 'Sherpa® es una marca registrada de The MountData.',
    privacy: 'Privacidad',
    and: 'y',
    terms: 'Términos',
    secretMonitor: '¿Existe un secreto para controlar todas sus campañas de marketing desde un solo lugar?',
    tellMeMore: '¡Explícame más!',
    results: 'resultados',
    downloadResults: 'Descargar resultados del buscador',
    noResults: 'Sin resultados',
    searcherNotAvailable: 'El buscador no está disponible',
    maxOptions: 'Máximo de {numOptions} opciones',
    select: 'Selecciona',
    selected: '{number} seleccionados',
    deleteSelected: 'borrar seleccionados',
    addSelected: 'añadir seleccionados',
    notSelected: 'no seleccionados',
    enterForSelect: 'Enter para selecc.',
    enterForDelete: 'Enter para borrar',
    filters: 'Seleccionar filtros',
    errorLengthMin: 'mínimo {lengthMin} caracteres',
    errorLengthMax: 'máximo {lengthMax} caracteres',
    errorNumberMin: 'mínimo {lengthMin}',
    errorNumberMax: 'máximo {lengthMax}',
    errorRegExp: 'formato incorrecto{message}',
    errorImgExt: 'tipo de imagen incorrecta{message}',
    errorMandatoryMinOne: 'mínimo {min} respuesta',
    errorMandatoryLanguageMinOne: 'faltan idiomas obligatorios',
    errorMandatoryMin: 'mínimo {min} respuestas',
    errorMandatoryMaxOne: 'máximo {max} respuesta',
    errorMandatoryMax: 'máximo {max} respuestas',
    errorDateFormat: 'Formato de fecha incorrecto{message}',
    errorNumIntervalFormat: 'Intervalo de número incorrecto{message}',
    errorHtmlFormat: 'Formato de html incorrecto{message}',
    save: 'GUARDAR y salir',
    saveAndNew: 'GUARDAR y crear uno nuevo',
    saveAndStay: 'GUARDAR',
    saveContentChanges: 'GUARDAR cambios',
    update: 'GUARDAR y salir',
    updateAndStay: 'GUARDAR',
    andStay: 'y permanecer',
    delete: 'Borrar',
    deleteAll: 'borrar todos',
    deleteHtml: 'Borrar contenido',
    linkClick: 'Haz clic aquí para abrir el enlace',
    linkFileClick: 'Haz clic aquí para abrir el fichero',
    confirmDeleteHtml: '¿Seguro que quieres borrar el contenido?',
    discardChanges: 'Descartar cambios',
    formErrors: 'Revisa los campos del formulario',
    formAddErrors: 'Revisa los campos para agregar el elemento',
    formModifyErrors: 'Revisa los campos para modificar el elemento',
    formSaved: 'Datos guardados correctamente',
    formAddSaved: 'Elemento agregado correctamente',
    formDeleted: 'Datos borrados correctamente',
    formConfirmDelete: '¿Realmente quieres borrar este elemento?',
    yes: 'sí',
    no: 'no',
    add: 'añadir a',
    added: 'añadidos/as',
    addAll: 'añadir todos',
    changeText: 'cambiar texto',
    whoSend: '¿A quien se envía (lista)?',
    uploadHtml: 'Subir HTML',
    subject: 'Asunto',
    examine: 'Examinar',
    scheduleShipping: 'Programar envío',
    template: 'Plantilla',
    saveDraft: 'Guardar borrador',
    saveEmail: 'Guadar email',
    newEmail: 'Crear nuevo email',
    search: 'buscar...',
    searchEmail: 'Buscar email',
    groupFields: 'Campos del grupo',
    searchFields: 'Buscar campos',
    noElements: 'Sin elementos',
    error400: 'Vuelve a iniciar sesión para refrescar tus permisos',
    error401: 'Error en usuario o contraseña',
    error401Remember: 'Error en usuario',
    error403: 'Sin permisos para acceder a este servicio',
    error404: 'Servicio no encontrado',
    error500: 'Error desconocido',
    error412: 'Usuario sin permisos.',
    error408: 'Ya han pasado 10 minutos.',
    error408Remember: 'Ya han pasado 10 minutos. Vuelve a solicitar renovar la contraseña',
    error408DoubleFactor: 'Ya han pasado 10 minutos. Vuelve a solicitar inicio de sesión',
    error429Remember: 'Sólo tienes 3 intentos. Vuelve a solicitar renovar la contraseña',
    error429DoubleFactor: 'Sólo tienes 3 intentos. Vuelve a solicitar inicio de sesión',
    error406Remember: 'El código que has introducido no es válido',
    fileDownloaded: 'Fichero descargado.',
    passwordFormat: 'Define tu nueva contraseña. Al menos 8 caracteres y mínimo: 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial (@#$%^&+!=)',
    passwordSetted: 'Contraseña renovada correctamente',
    incorrectPasswordFormat: 'El formato de la contraseña no es correcto',
    incorrectPasswordRepeat: 'Las dos contraseñas no son iguales',
    correctPasswordFormatLength: 'Tiene como mínimo 8 caracteres',
    correctPasswordFormatUppercase: 'Contiene una mayúscula',
    correctPasswordFormatLowercase: 'Contiene una minúscula',
    correctPasswordFormatNumber: 'Contiene un número',
    correctPasswordFormatSpecial: 'Contiene algún caracter especial @#$%^&+!=.',
    correctPasswordFormatRepeat: 'Las contraseñas son iguales',
    rememberSuccess: 'Revisa tu email para introducir el código y renovar la contraseña',
    doubleFactorCodeSuccess: 'Revisa tu email para introducir el código de inicio de sesión',
    error500header: 'Error inesperado. Contacta con el administrador del sistema',
    errorLoginEmpty: 'Campos obligatorios',
    errorTaskValidation: 'Completa toda la información para poder ejecutar la tarea.',
    edit: 'Editar',
    visit: 'Visitar',
    see: 'Ver',
    cancel: 'Cancelar',
    cancelChanges: 'CANCELAR cambios',
    infoNewForm: 'Arrastrar los items para construir aquí el formulario',
    addGroup: 'Añadir grupo',
    addSection: 'Añadir Sección',
    saveForm: 'Guardar formulario',
    newForm: 'Crear nuevo formulario',
    searchForms: 'Buscar formularios',
    searchSms: 'Buscar SMS',
    saveSms: 'Guardar SMS',
    newSms: 'Crear nuevo SMS',
    newAds: 'Crear nuevo banner',
    searchAds: 'Campañas display',
    taskError: 'Error en la tarea.',
    remainCharacters: '{count}/{maxLength}',
    of: 'de',
    noImage: 'sin imagen',
    nofile: 'selecciona un archivo',
    saveChanges: '¿Quieres guardar los cambios antes de continuar?',
    saveChangesAfterClose: '¿Deseas guardar los cambios antes de cerrar?',
    continueWithoutSaving: 'Continuar sin guardar',
    id: 'id',
    emojiSelect: 'selecciona emoticono...',
    emojiSearch: 'Buscar',
    emojiNotfound: 'Emoticono no encontrado',
    emojiCategoriesSearch: 'Resultados',
    emojiCategoriesRecent: 'Usados recientemente',
    emojiCategoriesPeople: 'Smileys y Gente',
    emojiCategoriesNature: 'Animales y Naturaleza',
    emojiCategoriesFoods: 'Comida y Bebida',
    emojiCategoriesActivity: 'Actividad',
    emojiCategoriesPlaces: 'Viajes y Sitios',
    emojiCategoriesObjects: 'Objetos',
    emojiCategoriesSymbols: 'Símbolos',
    emojiCategoriesFlags: 'Banderas',
    emojiCategoriesCustom: 'Personalizado',
    translate: 'traducir a los otros idiomas no definidos',
    copyText: 'copiar el texto a los otros idiomas no definidos',
    questions: 'preguntas',
    questionText: 'Texto de la pregunta',
    dictFallbackMessage: 'Tu navegador no soporta la capacidad de arrastrar archivos para subirlos.',
    dictFallbackText: 'Por favor, utiliza el formulario de reserva de abajo para subir tus archivos, como en los viejos tiempos.',
    dictFileTooBig: 'Archivo demasiado grande ({{filesize}}MiB). Tamaño máximo: {{maxFilesize}}MiB.',
    dictInvalidFileType: 'No puedes subir archivos de este tipo.',
    dictResponseError: 'El servidor ha contestado con el código {{statusCode}}.',
    dictCancelUpload: 'Cancelar subida',
    dictCancelUploadConfirmation: '¿Estás seguro de cancelar la subida de archivos?',
    dictRemoveFile: 'Eliminar archivo',
    dictMaxFilesExceeded: 'No puedes subir más archivos.',
    sectionTasks: 'Tareas de Sección',
    addTask: 'Añadir tarea',
    addIndividualParamsTitle: 'Variable Particular',
    addProfessionalParamsTitle: 'Variable Profesional',
    addIndicatorParamsTitle: 'Variable Indicador',
    addMeetingParamsTitle: 'Variable Reunión',
    addMinutesParamsTitle: 'Variable Acta',
    addCertificateParamsTitle: 'Variable Certificado',
    seeTasks: 'Ver tareas',
    nextStep: 'Siguiente paso',
    previousStep: 'Paso previo',
    type: 'Tipo',
    tree: 'Árbol',
    cluster: 'Clúster',
    orientation: 'Orientación',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    circular: 'Circular',
    nodeTextDisplay: 'Visualización del texto',
    all: 'Todo',
    leaves: 'Hojas',
    extremities: 'Extremidades',
    linkLayout: 'Visualización del enlace',
    bezier: 'Bezier',
    orthogonal: 'Ortogonal',
    available: 'Inactivas',
    multiSelected: 'Activas',
    moveAll: 'Mover todos',
    datepicker: {
      days: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      months: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      pickers: ['sig. 7 días', 'sig. 30 días', 'últ. 7 días', 'últ. 30 días'],
      placeholder: {
        date: 'Selecciona fecha',
        dateRange: 'Selecciona rango de fechas',
        duration: 'Tiempo de duración',
        time: 'Tiempo'
      }
    },
    cron: {
      Seconds: {
        name: 'Segundos',
        every: 'Cada segundo',
        interval: ['Cada', 'segundo(s) comenzando en el segundo'],
        specific: 'Segundo específico (escoge uno o varios)',
        cycle: ['Cada segundo entre el segundo', 'y el segundo']
      },
      Minutes: {
        name: 'Minutos',
        every: 'Cada minuto',
        interval: ['Cada', 'minuto(s) comenzando en el minuto'],
        specific: 'Minuto específico (escoge uno o varios)',
        cycle: ['Cada minuto entre el minuto', 'y el minuto']
      },
      Hours: {
        name: 'Horas',
        every: 'Cada hora',
        interval: ['Cada', 'hora(s) comenzando en la hora'],
        specific: 'Hora específica (escoge una o varias)',
        cycle: ['Cada hora entre la hora', 'y la hora']
      },
      Day: {
        name: 'Día',
        every: 'Cada día',
        intervalWeek: ['Cada', 'día(s) comenzando el'],
        intervalDay: ['Cada', 'día(s) comenzando el día', 'del mes'],
        specificWeek: 'Día de la semana específico (escoge uno o varios)',
        specificDay: 'Día del mes específico (escoge uno o varios)',
        lastDay: 'El último día del mes',
        lastWeekday: 'El último día laborable (de Lunes a Viernes) del mes',
        lastWeek: ['El último', ' del mes'],
        beforeEndMonth: ['día(s) antes de final de mes'],
        nearestWeekday: ['El día laborable (de Lunes a Viernes) más cercano al', 'del mes'],
        someWeekday: ['El', 'del mes']
      },
      Week: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      Month: {
        name: 'Mes',
        every: 'Cada mes',
        interval: ['Cada', 'mes(es) comenzando en'],
        specific: 'Mes específico (escoge uno o varios)',
        cycle: ['Cada mes entre', 'y']
      },
      Year: {
        name: 'Año',
        every: 'Cada año',
        interval: ['Cada', 'año(s) comenzando en'],
        specific: 'Año específico (escoge uno o varios)',
        cycle: ['Cada año entre', 'y']
      }
    },
    formBuilder: {
      group: 'Grupo de preguntas',
      typeText: 'Texto',
      typeDomain: 'Dominio de respuestas',
      typeDate: 'Fecha',
      dropItemsHere: 'Arrastra los elementos aquí...',
      currentLanguage: 'Idioma',
      emptyName: 'texto no definido',
      translations: 'Traducciones de',
      active: 'Activo',
      inactive: 'Inactivo',
      read: 'Campo sólo legible',
      create: 'Editable al crear',
      update: 'Editable al crear / modificar',
      required: 'Obligatorio',
      optional: 'Opcional',
      responsesNumber: 'Número de respuestas',
      responseSelection: 'Selección de respuestas',
      available: 'Inactivas',
      selected: 'Activas',
      moveAll: 'Mover todos',
      preselected: 'Predeterminada',
      selectable: 'Seleccionable',
      save: 'GUARDAR y salir',
      saveAndStay: 'GUARDAR',
      saveResults: 'Resultados de la operación',
      saveResultsOk: 'Las preguntas del formulario se han guardado correctamente.',
      saveResultsKo: 'Hay algún error guardando los datos:',
      errorUnknownId: 'Desconocido',
      errorUnknownText: 'Contacte con el administrador del sistema',
      conditional: 'condicional',
      notConditional: 'no condicional',
      visibleWith: 'Visible con',
      allOptionValues: 'Todas las opciones'
    },
    segmentBuilder: {
      group: 'Grupo de condiciones',
      typeText: 'Texto',
      typeDomain: 'Dominio de respuestas',
      typeDate: 'Fecha',
      typeNumber: 'Número',
      dropItemsHere: 'Arrastra los elementos aquí...',
      active: 'Activo',
      inactive: 'Inactivo',
      conditionsGroupName: 'descripción del grupo de condiciones...',
      and: 'and',
      or: 'or',
      minus: 'minus',
      operation: 'Operación',
      conditionRequired: 'se tiene que cumplir esta condición.',
      someConditionGroupRequired: 'se tiene que complir ALGUNA de las condiciones de grupo.',
      responseSelection: 'Valores',
      textSelection: 'Texto',
      numberSelection: 'Número',
      dateSelection: 'Fecha',
      diffDays: 'Número de días antes (-) / después',
      available: 'Disponibles',
      moveAll: 'Mover todos',
      selected: 'Seleccionados',
      from: 'desde',
      to: 'hasta',
      opDomainEqualName: 'Exactamente igual',
      opDomainEqualDesc: 'Tiene exactamente los mismos valores seleccionados.',
      opDomainContainsAllName: 'Contiene todo',
      opDomainContainsAllDesc: 'Contiene todos los valores seleccionados.',
      opDomainContainsSomeName: 'Contiene alguno',
      opDomainContainsSomeDesc: 'Contiene al menos uno de los valores seleccionados.',
      opDomainNotContainsName: 'No contiene ninguno',
      opDomainNotContainsDesc: 'No contiene ninguno de los valores seleccionados.',
      opDomainInformedName: 'Informado',
      opDomainInformedDesc: 'El campo está informado con cualquier valor.',
      opDomainNotInformedSomeName: 'No informado',
      opDomainNotInformedSomeDesc: 'El campo no está informado con ningún valor (nulo).',
      opTextEqualName: 'Igual',
      opTextEqualDesc: 'Texto exactamente igual.',
      opTextContainsName: 'Contiene',
      opTextContainsDesc: 'Contiene el texto (\'*manzana*\').',
      opTextStartsWithName: 'Empieza con',
      opTextStartsWithDesc: 'Empieza con el texto (\'manzana*\').',
      opTextEndsWithName: 'Acaba con',
      opTextEndsWithDesc: 'Acaba con el texto (\'*manzana\').',
      opTextNotEqualName: 'No igual',
      opTextNotEqualDesc: 'El texto es diferente.',
      opTextNotContainsName: 'No contiene',
      opTextNotContainsDesc: 'El texto no contiene lo especificado.',
      opTextOnListName: 'En la lista',
      opTextOnListDesc: 'Dentro de la lista de textos (separados por \'|\')',
      opTextOffListName: 'Fuera de la lista',
      opTextOffListDesc: 'Fuera de la lista de textos (separados por \'|\')',
      opTextInformedName: 'Informado',
      opTextInformedDesc: 'El campo está informado con cualquier valor.',
      opTextNotInformedSomeName: 'No informado',
      opTextNotInformedSomeDesc: 'El campo no está informado con ningún valor (nulo).',
      opNumberEqualName: 'Igual',
      opNumberEqualDesc: 'Número igual.',
      opNumberNotEqualName: 'Diferente',
      opNumberNotEqualDesc: 'Número diferente.',
      opNumberBetweenName: 'Entre',
      opNumberBetweenDesc: 'Número entre el rango de valores.',
      opNumberNotBetweenName: 'No entre',
      opNumberNotBetweenDesc: 'Número fuera del rango de valores.',
      opNumberBiggerName: 'Más grande',
      opNumberBiggerDesc: 'Número más grande.',
      opNumberBiggerOrEqualName: 'Más grande o igual',
      opNumberBiggerOrEqualDesc: 'Número más grande o igual.',
      opNumberLessName: 'Más pequeño',
      opNumberLessDesc: 'Número más pequeño.',
      opNumberLessOrEqualName: 'Más pequeño o igual',
      opNumberLessOrEqualDesc: 'Número más pequeño o igual.',
      opNumberOnListName: 'En la lista',
      opNumberOnListDesc: 'Dentro de la lista de números (separados por espacios)',
      opNumberOffListName: 'Fuera de la lista',
      opNumberOffListDesc: 'Fuera de la lista de números (separados por espacios)',
      opNumberInformedName: 'Informado',
      opNumberInformedDesc: 'El campo está informado con cualquier valor.',
      opNumberNotInformedSomeName: 'No informado',
      opNumberNotInformedSomeDesc: 'El campo no está informado con ningún valor (nulo).',
      opDateEqualName: 'Igual',
      opDateEqualDesc: 'Número igual.',
      opDateNotEqualName: 'Diferente',
      opDateNotEqualDesc: 'Fecha diferente.',
      opDateBetweenName: 'Entre',
      opDateBetweenDesc: 'Fecha entre el rango de valores.',
      opDateNotBetweenName: 'No entre',
      opDateNotBetweenDesc: 'Fecha fuera del rango de valores.',
      opDateBiggerName: 'Más grande',
      opDateBiggerDesc: 'Fecha más grande.',
      opDateBiggerOrEqualName: 'Más grande o igual',
      opDateBiggerOrEqualDesc: 'Fecha más grande o igual.',
      opDateLessName: 'Más pequeño',
      opDateLessDesc: 'Fecha más pequeña.',
      opDateLessOrEqualName: 'Más pequeño o igual',
      opDateLessOrEqualDesc: 'Fecha más pequeña o igual.',
      opDateYearDayName: 'Día del año',
      opDateYearDayDesc: 'Con el mismo dia y mes de cada año',
      opDateYearDayTodayName: 'Hoy de todos los años',
      opDateYearDayTodayDesc: 'Como el día de hoy de cada año',
      opDateTodayName: 'Hoy',
      opDateTodayDesc: 'Como hoy',
      opDateWeekDaysName: 'Días de la semana',
      opDateWeekDaysDesc: 'Dentro de los días de la semana seleccionados',
      weekDays: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
      opDateMonthDaysName: 'Días del mes',
      opDateMonthDaysDesc: 'Dentro de los días del mes seleccionados',
      opDateYearMonthsName: 'Meses',
      opDateYearMonthsDesc: 'Dentro de los meses seleccionados',
      days: 'días',
      daysLabel: 'Días',
      months: 'Meses',
      opDateInformedName: 'Informado',
      opDateInformedDesc: 'El campo está informado con cualquier valor.',
      opDateNotInformedSomeName: 'No informado',
      opDateNotInformedSomeDesc: 'El campo no está informado con ningún valor (nulo).',
      saveAndStay: 'GUARDAR',
      saveResults: 'Resultados de la operación',
      saveResultsOk: 'Los valores del segmento se han guardado correctamente.',
      saveResultsKo: 'Hay algún error guardando los datos:',
      totalRows: 'Resultados:',
      totalQuestionItemRows: 'Resultados de este filtro:',
      totalGroupRows: 'Resultados de este grupo:',
      genericFilters: 'Filtros genéricos',
      conditionsOf: 'Condiciones de',
      chatTitle: 'Asistente IA',
      chatSummaryIntro: 'Condiciones actuales del segmento:',
      chatNoConditions: 'El segmento no tiene condiciones todavía.',
      chatEmptyDesc: 'Describe en lenguaje natural las condiciones que quieres añadir o modificar en el segmento.',
      chatEmptyExample: '"Clientes con más de 2 compras en los últimos 30 días que vivan en Madrid"',
      chatPlaceholder: 'Describe las condiciones...',
      chatError: 'Error al conectar con el asistente.',
      chatErrorConditions: 'No se han podido procesar las condiciones. Inténtalo de nuevo.'
    }
  },
  'ca_ES': {
    isoCode: 'ca_ES', // required!
    empty: '',
    language: 'Idioma',
    ca_ES: 'Català',
    es_ES: 'Espanyol',
    en_GB: 'Anglès',
    welcomehombre: 'Benvingut {name}',
    welcomemujer: 'Benvinguda {name}',
    closeSession: 'Tancar sessió',
    close: 'tancar',
    username: 'Usuari',
    password: 'Contrasenya',
    forgotUsername: 'Ha oblidat l\'usuari?',
    forgotPassword: 'Ha oblidat la contrasenya?',
    activeSession: 'Manteniu la sessió activa',
    enter: 'entrar',
    rememberPassword: 'renovar contrasenya',
    rememberUser: 'Introdueix el teu usuari i t\'enviarem un email per renovar la teva contrasenya',
    checkRememberCode: 'Valida el codi',
    checkRememberPassword: 'Guardar nova contrasenya',
    newPasword: 'Nova contrasenya',
    repeatPassword: 'Repeteix la contrasenya',
    allRightsReserved: '© CCOO de Catalunya',
    registeredTrademark: 'Sherpa® és una marca registrada de The MountData.',
    privacy: 'Privacitat',
    and: 'i',
    terms: 'Termes',
    secretMonitor: 'Existeix un secret per controlar totes les seves campanyes de marketing des de un únic lloc?',
    tellMeMore: 'Explica\'m més!',
    results: 'resultats',
    downloadResults: 'Descarregar resultats del cercador',
    noResults: 'Sense resultats',
    searcherNotAvailable: 'El cercador no està disponible',
    maxOptions: 'Màxim de {numOptions} opcions',
    select: 'Selecciona',
    selected: '{number} seleccionats',
    deleteSelected: 'esborrar seleccionats',
    addSelected: 'afegir seleccionats',
    notSelected: 'no seleccionats',
    enterForSelect: 'Enter per selecc.',
    enterForDelete: 'Enter per esborrar',
    filters: 'Seleccionar filtres',
    errorLengthMin: 'mínim {lengthMin} caràcters',
    errorLengthMax: 'màxim {lengthMax} caràcters',
    errorNumberMin: 'mínim {lengthMin}',
    errorNumberMax: 'màxim {lengthMax}',
    errorRegExp: 'format incorrecte{message}',
    errorImgExt: 'tipus d\'imatge incorrecte{message}',
    errorMandatoryMinOne: 'mínim {min} resposta',
    errorMandatoryLanguageMinOne: 'falten idiomes obligatoris',
    errorMandatoryMin: 'mínim {min} respostes',
    errorMandatoryMaxOne: 'màxim {max} resposta',
    errorMandatoryMax: 'màxim {max} respostes',
    errorDateFormat: 'Format de data incorrecte{message}',
    errorNumIntervalFormat: 'Interval de número incorrecte{message}',
    errorHtmlFormat: 'Format d\'html incorrecte{message}',
    save: 'GUARDAR i sortir',
    saveAndNew: 'GUARDAR i crear un nou',
    saveAndStay: 'GUARDAR',
    saveContentChanges: 'GUARDAR canvis',
    update: 'GUARDAR i sortir',
    updateAndStay: 'GUARDAR',
    andStay: 'i romandre',
    delete: 'Esborrar',
    deleteAll: 'Esborrar tots',
    deleteHtml: 'Esborrar contingut',
    linkClick: 'Fes clic aquí per obrir l\'enllaç',
    linkFileClick: 'Fes clic aquí per obrir el fitxer',
    confirmDeleteHtml: 'Segur que vols esborrar el contingut?',
    discardChanges: 'Descartar canvis',
    formErrors: 'Revisa els camps del formulari',
    formAddErrors: 'Revisa els camps per afegir l\'element',
    formModifyErrors: 'Revisa els camps per modificar l\'element',
    formSaved: 'Dades guardades correctament',
    formAddSaved: 'Element afegit correctament',
    formDeleted: 'Dades esborrades correctament',
    formConfirmDelete: 'Realment vols esborrar aquest element?',
    yes: 'si',
    no: 'no',
    add: 'afegir a',
    added: 'afegits/des',
    addAll: 'afegir tots',
    changeText: 'canviar text',
    whoSend: 'A qui s\'envia (llista)?',
    uploadHtml: 'Pujar HTML',
    subject: 'Assumpte',
    examine: 'Examinar',
    scheduleShipping: 'Programar enviament',
    template: 'Plantilla',
    saveDraft: 'Guardar esborrany',
    saveEmail: 'Guadar email',
    newEmail: 'Crear nou email',
    search: 'cercar...',
    searchEmail: 'Cercar email',
    groupFields: 'Camps del grup',
    searchFields: 'Cercar camps',
    noElements: 'Sense elements',
    error400: 'Torna a iniciar sessió per refrescar els teus permisos',
    error401: 'Error a l\'usuari o contrasenya',
    error401Remember: 'Error a l\'usuari',
    error403: 'Sense permisos per accedir a aquest servei',
    error404: 'Servei no trobat',
    error500: 'Error desconegut',
    error412: 'Usuari sense permisos.',
    error408: 'Ja han passat 10 minuts.',
    error408Remember: 'Ja han passat 10 minuts. Torna a sol·licitar renovar la contrasenya',
    error408DoubleFactor: 'Ja han passat 10 minuts. Torna a sol·licitar inici de sessió',
    error429Remember: 'Només tens 3 intents. Torna a sol·licitar renovar la contrasenya',
    error429DoubleFactor: 'Només tens 3 intents. Torna a sol·licitar inici de sessió',
    error406Remember: 'El codi que has introduit no és vàlid',
    fileDownloaded: 'Fitxer descarregat.',
    passwordFormat: 'Defineix la teva nova contrasenya. Com a mínim 8 caràcters i mínim: 1 majúscula, 1 minúscula, 1 número i 1 caràcter especial (@#$%^&+!=)',
    passwordSetted: 'Contrasenya renovada correctament',
    incorrectPasswordFormat: 'El format de la contrasenya no és correcte',
    incorrectPasswordRepeat: 'Les dues contrasenyes no són iguals',
    correctPasswordFormatLength: 'Té com a mínim 8 caràcters',
    correctPasswordFormatUppercase: 'Conté una majúscula',
    correctPasswordFormatLowercase: 'Conté una minúscula',
    correctPasswordFormatNumber: 'Conté un número',
    correctPasswordFormatSpecial: 'Conté algun caràcter especial @#$%^&+!=.',
    correctPasswordFormatRepeat: 'Les contrasenyes coincideixen',
    rememberSuccess: 'Revisa el teu email per introduir el codi i renovar la contrasenya',
    doubleFactorCodeSuccess: 'Revisa el teu email per introduir el codi d\'inici de sessió',
    error500header: 'Error inesperat. Contacta amb l\'administrador del sistema',
    errorLoginEmpty: 'Camps obligatoris',
    errorTaskValidation: 'Completa tota la informació per poder executar la tasca.',
    edit: 'Editar',
    visit: 'Visitar',
    see: 'Veure',
    cancel: 'Cancel·lar',
    cancelChanges: 'CANCEL·LAR canvis',
    infoNewForm: 'Arrossegar els items aquí per construir el formulari',
    addGroup: 'Afegir grup',
    addSection: 'Afegir secció',
    saveForm: 'Guardar formulari',
    newForm: 'Crear nou formulari',
    searchForms: 'Cercar formularis',
    searchSms: 'Cercar SMS',
    saveSms: 'Guardar SMS',
    newSms: 'Crear nou SMS',
    newAds: 'Crear nou banner',
    searchAds: 'Campanyes display',
    taskError: 'Error a la tasca.',
    remainCharacters: '{count}/{maxLength}',
    of: 'de',
    noImage: 'sense imatge',
    nofile: 'selecciona un arxiu',
    saveChanges: 'Vols guardar els canvis abans de continuar?',
    saveChangesAfterClose: 'Vols guardar els canvis abans de tancar?',
    continueWithoutSaving: 'Continuar sense guardar',
    id: 'id',
    emojiSelect: 'selecciona emoticona...',
    emojiSearch: 'Cercar',
    emojiNotfound: 'Emoticona no trobada',
    emojiCategoriesSearch: 'Resultats',
    emojiCategoriesRecent: 'Utilitzats recentment',
    emojiCategoriesPeople: 'Smileys i Gent',
    emojiCategoriesNature: 'Animals i Natura',
    emojiCategoriesFoods: 'Menjar i Beguda',
    emojiCategoriesActivity: 'Activitat',
    emojiCategoriesPlaces: 'Viatges i Llocs',
    emojiCategoriesObjects: 'Objectes',
    emojiCategoriesSymbols: 'Símbols',
    emojiCategoriesFlags: 'Banderes',
    emojiCategoriesCustom: 'Personalitzat',
    translate: 'traduir als altres idiomes no definits',
    copyText: 'copiar el text als altres idiomes no definits',
    questions: 'preguntes',
    questionText: 'Text de la pregunta',
    dictFallbackMessage: 'El teu navegador no soporta la capacitat d\'arrossegar arxius per pujar-los.',
    dictFallbackText: 'Si us plau, utiliza el formulari de reserva de sota per pujar els teus arxius, com als vells temps.',
    dictFileTooBig: 'Arxiu massa gran ({{filesize}}MiB). Tamany màxim: {{maxFilesize}}MiB.',
    dictInvalidFileType: 'No pots pujar arxius d\'aquest tipus.',
    dictResponseError: 'El servidor ha contestat amb el codi {{statusCode}}.',
    dictCancelUpload: 'Cancel·lar pujada',
    dictCancelUploadConfirmation: 'Estàs segur de cancel·lar la pujada d\'arxius?',
    dictRemoveFile: 'Eliminar arxiu',
    dictMaxFilesExceeded: 'No pots pujar més arxius.',
    sectionTasks: 'Tasques de Secció',
    addTask: 'Afegir tasca',
    addIndividualParamsTitle: 'Variable Particular',
    addProfessionalParamsTitle: 'Variable Professional',
    addIndicatorParamsTitle: 'Variable Indicador',
    addMeetingParamsTitle: 'Variable Reunió',
    addMinutesParamsTitle: 'Variable Acta',
    addCertificateParamsTitle: 'Variable Certificat',
    seeTasks: 'Veure tasques',
    nextStep: 'Següent pas',
    previousStep: 'Pas previ',
    type: 'Tipus',
    tree: 'Arbre',
    cluster: 'Clúster',
    orientation: 'Orientació',
    vertical: 'Vertical',
    horizontal: 'Horitzontal',
    circular: 'Circular',
    nodeTextDisplay: 'Visualització del text',
    all: 'Tot',
    leaves: 'Fulles',
    extremities: 'Extremitats',
    linkLayout: 'Visualització de l\'enllaç',
    bezier: 'Bezier',
    orthogonal: 'Ortogonal',
    available: 'Inactives',
    multiSelected: 'Actives',
    moveAll: 'Moure tots',
    datepicker: {
      days: ['Diu', 'Dil', 'Dmt', 'Dmc', 'Dij', 'Div', 'Dis'],
      months: ['Gen', 'Feb', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Oct', 'Nov', 'Des'],
      pickers: ['seg. 7 dies', 'seg. 30 dies', 'últ. 7 dies', 'últ. 30 dies'],
      placeholder: {
        date: 'Selecciona data',
        dateRange: 'Selecciona rang de dates',
        duration: 'Temps de durada',
        time: 'Temps'
      }
    },
    cron: {
      Seconds: {
        name: 'Segons',
        every: 'Cada segon',
        interval: ['Cada', 'segon(s) començant al segon'],
        specific: 'Segon específic (escull un o diversos)',
        cycle: ['Cada segon entre el segon', 'i el segon']
      },
      Minutes: {
        name: 'Minuts',
        every: 'Cada minut',
        interval: ['Cada', 'minut(s) començant al minut'],
        specific: 'Minut específic (escull un o diversos)',
        cycle: ['Cada minut entre el minut', 'i el minut']
      },
      Hours: {
        name: 'Hores',
        every: 'Cada hora',
        interval: ['Cada', 'hora(es) començant a l\'hora'],
        specific: 'Hora específica (escull una o diverses)',
        cycle: ['Cada hora entre l\'hora', 'i l\'hora']
      },
      Day: {
        name: 'Dia',
        every: 'Cada dia',
        intervalWeek: ['Cada', 'dia(es) començant el'],
        intervalDay: ['Cada', 'dia(es) començant el dia', 'del mes'],
        specificWeek: 'Dia de la setmana específic (escull un o diversos)',
        specificDay: 'Dia del mes específic (escull un o diversos)',
        lastDay: 'L\'últim dia del mes',
        lastWeekday: 'L\'últim dia laborable (de dilluns a divendres) del mes',
        lastWeek: ['L\'últim', ' del mes'],
        beforeEndMonth: ['dia(es) abans de final de mes'],
        nearestWeekday: ['El dia laborable (de dilluns a divendres) més proper al', 'del mes'],
        someWeekday: ['El', 'del mes']
      },
      Week: ['Diumenge', 'Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte'],
      Month: {
        name: 'Mes',
        every: 'Cada mes',
        interval: ['Cada', 'mes(os) començant al'],
        specific: 'Mes específic (escull un o diversos)',
        cycle: ['Cada mes entre', 'i']
      },
      Year: {
        name: 'Any',
        every: 'Cada any',
        interval: ['Cada', 'any(s) començant al'],
        specific: 'Any específic (escull un o diversos)',
        cycle: ['Cada any entre', 'i']
      }
    },
    formBuilder: {
      group: 'Grup de preguntes',
      typeText: 'Text',
      typeDomain: 'Domini de respostes',
      typeDate: 'Data',
      dropItemsHere: 'Arrossega els elements aquí...',
      currentLanguage: 'Idioma',
      emptyName: 'text no definit',
      translations: 'Traduccions de',
      active: 'Actiu',
      inactive: 'Inactiu',
      read: 'Camp només llegible',
      create: 'Editable al crear',
      update: 'Editable al crear / modificar',
      required: 'Obligatori',
      optional: 'Opcional',
      responsesNumber: 'Número de respostes',
      responseSelection: 'Selecció de respostes',
      available: 'Inactives',
      selected: 'Actives',
      moveAll: 'Moure tots',
      preselected: 'Predeterminada',
      selectable: 'Seleccionable',
      save: 'GUARDAR i sortir',
      saveAndStay: 'GUARDAR',
      saveResults: 'Resultats de l\'operació',
      saveResultsOk: 'Les preguntes del formulari s\'han guardat correctament.',
      saveResultsKo: 'Hi ha algún error al guardar les dades:',
      errorUnknownId: 'Desconegut',
      errorUnknownText: 'Contacti amb l\'administrador del sistema',
      conditional: 'condicional',
      notConditional: 'no condicional',
      visibleWith: 'Visible amb',
      allOptionValues: 'Totes les opcions'
    },
    segmentBuilder: {
      group: 'Grup de condicions',
      typeText: 'Text',
      typeDomain: 'Domini de respostes',
      typeDate: 'Data',
      typeNumber: 'Número',
      dropItemsHere: 'Arrossega els elements aquí...',
      active: 'Actiu',
      inactive: 'Inactiu',
      conditionsGroupName: 'descripció del grup de condicions...',
      and: 'and',
      or: 'or',
      minus: 'minus',
      operation: 'Operació',
      conditionRequired: 's\'ha de complir aquesta condició.',
      someConditionGroupRequired: 's\'ha de complir ALGUNA de les condicions de grup.',
      responseSelection: 'Valors',
      textSelection: 'Text',
      numberSelection: 'Número',
      dateSelection: 'Data',
      diffDays: 'Número de dies abans (-) / després',
      available: 'Disponibles',
      moveAll: 'Moure tots',
      selected: 'Seleccionats',
      from: 'des de',
      to: 'fins',
      opDomainEqualName: 'Exactament igual',
      opDomainEqualDesc: 'Té exactament els mateixos valors.',
      opDomainContainsAllName: 'Conté tots',
      opDomainContainsAllDesc: 'Conté tots els valor seleccionats.',
      opDomainContainsSomeName: 'Conté algún',
      opDomainContainsSomeDesc: 'Conté com a mínim un dels valors seleccionats.',
      opDomainNotContainsName: 'No conté cap',
      opDomainNotContainsDesc: 'No té cap dels valors seleccionats.',
      opDomainInformedName: 'Informat',
      opDomainInformedDesc: 'El camp está informat amb qualsevol valor.',
      opDomainNotInformedSomeName: 'No informat',
      opDomainNotInformedSomeDesc: 'El camp no está informat amb cap valor (nul).',
      opTextEqualName: 'Igual',
      opTextEqualDesc: 'Text exactament igual.',
      opTextContainsName: 'Conté',
      opTextContainsDesc: 'Conté el text (\'*poma*\').',
      opTextStartsWithName: 'Comença amb',
      opTextStartsWithDesc: 'Comença amb el text (\'poma*\').',
      opTextEndsWithName: 'Acaba amb',
      opTextEndsWithDesc: 'Acaba amb el text (\'*poma\').',
      opTextNotEqualName: 'No igual',
      opTextNotEqualDesc: 'El text és diferent.',
      opTextNotContainsName: 'No conté',
      opTextNotContainsDesc: 'El text no conté l\'especificat',
      opTextOnListName: 'A la lista',
      opTextOnListDesc: 'Dins de la lista de textos (separats per \'|\')',
      opTextOffListName: 'Fora de la lista',
      opTextOffListDesc: 'Fora de la lista de textos (separats per \'|\')',
      opTextInformedName: 'Informat',
      opTextInformedDesc: 'El camp està informat amb qualsevol valor.',
      opTextNotInformedSomeName: 'No informat',
      opTextNotInformedSomeDesc: 'El camp no está informat amb cap valor (nul).',
      opNumberEqualName: 'Igual',
      opNumberEqualDesc: 'Número igual.',
      opNumberNotEqualName: 'Diferent',
      opNumberNotEqualDesc: 'Número diferent.',
      opNumberBetweenName: 'Entre',
      opNumberBetweenDesc: 'Número dins del rang de valors.',
      opNumberNotBetweenName: 'No entre',
      opNumberNotBetweenDesc: 'Número fora del rang de valors.',
      opNumberBiggerName: 'Més gran',
      opNumberBiggerDesc: 'Número més gran.',
      opNumberBiggerOrEqualName: 'Més gran o igual',
      opNumberBiggerOrEqualDesc: 'Número més gran o igual.',
      opNumberLessName: 'Més petit',
      opNumberLessDesc: 'Número més petit.',
      opNumberLessOrEqualName: 'Més petit o igual',
      opNumberLessOrEqualDesc: 'Número més petit o igual.',
      opNumberOnListName: 'A la llista',
      opNumberOnListDesc: 'Dins de la llista de números (separats per espais)',
      opNumberOffListName: 'Fora de la llista',
      opNumberOffListDesc: 'Fora de la llista de números (separats per espais)',
      opNumberInformedName: 'Informat',
      opNumberInformedDesc: 'El camp està informat amb qualsevol valor.',
      opNumberNotInformedSomeName: 'No informat',
      opNumberNotInformedSomeDesc: 'El camp no està informat amb cap valor (nul).',
      opDateEqualName: 'Igual',
      opDateEqualDesc: 'Data igual.',
      opDateNotEqualName: 'Diferent',
      opDateNotEqualDesc: 'Data diferent.',
      opDateBetweenName: 'Entre',
      opDateBetweenDesc: 'Data dins del rang de valors.',
      opDateNotBetweenName: 'No entre',
      opDateNotBetweenDesc: 'Data fora del rang de valors.',
      opDateBiggerName: 'Més gran',
      opDateBiggerDesc: 'Data posterior.',
      opDateBiggerOrEqualName: 'Més gran o igual',
      opDateBiggerOrEqualDesc: 'Data posterior o igual.',
      opDateLessName: 'Més petita',
      opDateLessDesc: 'Data anterior.',
      opDateLessOrEqualName: 'Més petita o igual',
      opDateLessOrEqualDesc: 'Data anterior o igual.',
      opDateYearDayName: 'Dia de l\'any',
      opDateYearDayDesc: 'Amb el mateix dia i mes de cada any',
      opDateYearDayTodayName: 'Avui de tots els anys',
      opDateYearDayTodayDesc: 'Com el dia d\'avui de cada any',
      opDateTodayName: 'Avui',
      opDateTodayDesc: 'Com avui',
      opDateWeekDaysName: 'Dies de la setmana',
      opDateWeekDaysDesc: 'Dins dels dies de la setmana seleccionats',
      weekDays: ['Dilluns', 'Dimarts', 'Dimecres', 'Dijous', 'Divendres', 'Dissabte', 'Diumenge'],
      opDateMonthDaysName: 'Dies del mes',
      opDateMonthDaysDesc: 'Dins dels dies del mes seleccionats',
      opDateYearMonthsName: 'Mesos',
      opDateYearMonthsDesc: 'Dins dels mesos seleccionats',
      days: 'dies',
      daysLabel: 'Dies',
      months: 'Mesos',
      opDateInformedName: 'Informat',
      opDateInformedDesc: 'El camp està informat amb qualsevol valor.',
      opDateNotInformedSomeName: 'No informat',
      opDateNotInformedSomeDesc: 'El camp no està informat amb cap valor (nul).',
      saveAndStay: 'GUARDAR',
      saveResults: 'Resultats de l\'operació',
      saveResultsOk: 'Els valors del segment s\'han guardat correctament.',
      saveResultsKo: 'Hi ha algún error al guardar les dades:',
      totalRows: 'Resultats:',
      totalQuestionItemRows: 'Resultats d\'aquest filtre:',
      totalGroupRows: 'Resultats d\'aquest grup:',
      genericFilters: 'Filtres genèrics',
      conditionsOf: 'Condicions de',
      chatTitle: 'Assistent IA',
      chatSummaryIntro: 'Condicions actuals del segment:',
      chatNoConditions: 'El segment encara no té condicions.',
      chatEmptyDesc: 'Descriu en llenguatge natural les condicions que vols afegir o modificar al segment.',
      chatEmptyExample: '"Clients amb més de 2 compres en els darrers 30 dies que visquin a Madrid"',
      chatPlaceholder: 'Descriu les condicions...',
      chatError: 'Error en connectar amb l\'assistent.',
      chatErrorConditions: 'No s\'han pogut processar les condicions. Torna-ho a intentar.'
    }
  },
  'en_GB': {
    isoCode: 'en_GB', // required!
    empty: '',
    language: 'Language',
    ca_ES: 'Catalan',
    es_ES: 'Spanish',
    en_GB: 'English',
    welcomehombre: 'Welcome {name}',
    welcomemujer: 'Welcome {name}',
    closeSession: 'Close session',
    close: 'close',
    username: 'Username',
    password: 'Password',
    forgotUsername: 'Forgot username?',
    forgotPassword: 'Forgot password?',
    activeSession: 'Keep the session active',
    enter: 'enter',
    rememberPassword: 'renew password',
    rememberUser: 'Enter your username and we will send you an email to renew your password',
    checkRememberCode: 'Validate the code',
    checkRememberPassword: 'Save new password',
    newPasword: 'New password',
    repeatPassword: 'Repeat password',
    allRightsReserved: '© CCOO de Catalunya',
    registeredTrademark: 'Sherpa® is a registered trademark of The MountData.',
    privacy: 'Privacy',
    and: 'and',
    terms: 'Terms',
    secretMonitor: 'Is there a secret to monitor all your marketing campaigns from a single place?',
    tellMeMore: 'Tell me more!',
    results: 'results',
    downloadResults: 'Download searcher results',
    noResults: 'No results',
    searcherNotAvailable: 'The searcher is not available',
    maxOptions: 'Maximum of {numOptions} options',
    select: 'Select',
    selected: '{number} selected',
    deleteSelected: 'delete selected',
    addSelected: 'add selected',
    notSelected: 'not selected',
    enterForSelect: 'Enter for select',
    enterForDelete: 'Enter for delete',
    filters: 'Select filters',
    errorLengthMin: '{lengthMin} chars min',
    errorLengthMax: '{lengthMax} chars max',
    errorNumberMin: '{lengthMin} min',
    errorNumberMax: '{lengthMax} max',
    errorRegExp: 'wrong format{message}',
    errorImgExt: 'wrong image type{message}',
    errorMandatoryMinOne: '{min} answer min',
    errorMandatoryLanguageMinOne: 'missing required languages',
    errorMandatoryMin: '{min} answers min',
    errorMandatoryMaxOne: '{max} answer max',
    errorMandatoryMax: '{max} answers max',
    errorDateFormat: 'Incorrect date format{message}',
    errorNumIntervalFormat: 'Incorrect number range{message}',
    errorHtmlFormat: 'Incorrect html format{message}',
    save: 'SAVE and exit',
    saveAndNew: 'SAVE and create a new one',
    saveAndStay: 'SAVE',
    saveContentChanges: 'SAVE changes',
    update: 'UPDATE and exit',
    updateAndStay: 'UPDATE',
    andStay: 'and stay',
    delete: 'Delete',
    deleteAll: 'delete all',
    deleteHtml: 'Delete content',
    linkClick: 'Click here to open the link',
    linkFileClick: 'Click here to open the file',
    confirmDeleteHtml: 'Are you sure you want to delete this content?',
    discardChanges: 'Discard changes',
    formErrors: 'Check form fields',
    formAddErrors: 'Check the fields to add the element',
    formModifyErrors: 'Check the fields to modify the element',
    formSaved: 'Saved data correctly',
    formAddSaved: 'Element added correctly',
    formDeleted: 'Deleted data correctly',
    formConfirmDelete: 'Do you really want to delete this element?',
    yes: 'yes',
    no: 'no',
    add: 'add to',
    added: 'added',
    addAll: 'add all',
    changeText: 'change text',
    whoSend: 'To whom is it sent (list)?',
    uploadHtml: 'Upload HTML',
    subject: 'Subject',
    examine: 'Examine',
    scheduleShipping: 'Schedule shipping',
    template: 'Template',
    saveDraft: 'Save draft',
    saveEmail: 'Save email',
    newEmail: 'New email',
    search: 'search...',
    searchEmail: 'Search email',
    groupFields: 'Group fields',
    searchFields: 'Search fields',
    noElements: 'No elements',
    error400: 'Log back in to refresh your permissions',
    error401: 'Error in user or password',
    error401Remember: 'Error in user',
    error403: 'No permission to access this service',
    error404: 'Service not found',
    error500: 'Error unknown',
    error412: 'User without rights.',
    error408: 'It\'s been 10 minutes',
    error408Remember: 'It\'s been 10 minutes. Please request a password reset',
    error408DoubleFactor: 'It\'s been 10 minutes. Please request a new login',
    error429Remember: 'You only have 3 attempts. Please request a password reset',
    error429DoubleFactor: 'You only have 3 attempts. Please request a new login',
    error406Remember: 'The code you entered is invalid',
    fileDownloaded: 'File downloaded.',
    passwordFormat: 'Define your new password. At least 8 characters and minimum: 1 uppercase, 1 lowercase, 1 number and 1 special character (@#$%^&+!=)',
    passwordSetted: 'Password renewed successfully',
    incorrectPasswordFormat: 'The password format is incorrect',
    incorrectPasswordRepeat: 'The two passwords aren\'t equals',
    correctPasswordFormatLength: 'Has at least 8 characters',
    correctPasswordFormatUppercase: 'Contains an uppercase letter',
    correctPasswordFormatLowercase: 'Contains a lowercase letter',
    correctPasswordFormatNumber: 'Contains a number',
    correctPasswordFormatSpecial: 'Contains a special character @#$%^&+!=.',
    correctPasswordFormatRepeat: 'The passwords match',
    rememberSuccess: 'Check your email to introduce the code and renew the password',
    doubleFactorCodeSuccess: 'Check your email to introduce the init session code',
    error500header: 'Unexpected error. Contact with the system administrator',
    errorLoginEmpty: 'Required fields',
    errorTaskValidation: 'Complete all the information to be able to execute the task.',
    edit: 'Edit',
    visit: 'Visit',
    see: 'See',
    cancel: 'Cancel',
    cancelChanges: 'CANCEL changes',
    infoNewForm: 'Drag the items to build the form here',
    addGroup: 'Add group',
    addSection: 'Add Section',
    saveForm: 'Save form',
    newForm: 'New form',
    searchForms: 'Search forms',
    searchSms: 'Search SMS',
    saveSms: 'Save SMS',
    newSms: 'New SMS',
    newAds: 'New banner',
    searchAds: 'Campaigns display',
    taskError: 'Task error.',
    remainCharacters: '{count}/{maxLength}',
    of: 'of',
    noImage: 'No image',
    nofile: 'select a file',
    saveChanges: 'Do you want to save the changes before continuing?',
    saveChangesAfterClose: 'Do you want to save the changes before closing?',
    continueWithoutSaving: 'Continue without saving',
    id: 'id',
    emojiSelect: 'pick emoji...',
    emojiSearch: 'Search',
    emojiNotfound: 'No Emoji Found',
    emojiCategoriesSearch: 'Search Results',
    emojiCategoriesRecent: 'Frequently Used',
    emojiCategoriesPeople: 'Smileys & People',
    emojiCategoriesNature: 'Animals & Nature',
    emojiCategoriesFoods: 'Food & Drink',
    emojiCategoriesActivity: 'Activity',
    emojiCategoriesPlaces: 'Travel & Places',
    emojiCategoriesObjects: 'Objects',
    emojiCategoriesSymbols: 'Symbols',
    emojiCategoriesFlags: 'Flags',
    emojiCategoriesCustom: 'Custom',
    translate: 'translate to other languages ​​not defined',
    copyText: 'copy text to other languages ​​not defined',
    questions: 'questions',
    questionText: 'Question text',
    dictFallbackMessage: 'Your browser does not support the ability to drag files to upload them.',
    dictFallbackText: 'Please use the booking form below to upload your files, as in the old days.',
    dictFileTooBig: 'File too big ({{filesize}}MiB). Maximum size: {{maxFilesize}}MiB.',
    dictInvalidFileType: 'You can not upload files of this type.',
    dictResponseError: 'The server has answered with the code {{statusCode}}.',
    dictCancelUpload: 'Cancel upload',
    dictCancelUploadConfirmation: 'Are you sure to cancel the file upload?',
    dictRemoveFile: 'Delete file',
    dictMaxFilesExceeded: 'You can not upload more files.',
    sectionTasks: 'Section Tasks',
    addTask: 'Add task',
    addIndividualParamsTitle: 'Particular Variable',
    addProfessionalParamsTitle: 'Professional Variable',
    addIndicatorParamsTitle: 'Indicator Variable',
    addMeetingParamsTitle: 'Meeting Variable',
    addMinutesParamsTitle: 'Minutes Variable',
    addCertificateParamsTitle: 'Certificate Variable',
    seeTasks: 'See tasks',
    nextStep: 'Next step',
    previousStep: 'Previous step',
    type: 'Type',
    tree: 'Tree',
    cluster: 'Cluster',
    orientation: 'Orientation',
    vertical: 'Vertical',
    horizontal: 'Horizontal',
    circular: 'Circular',
    nodeTextDisplay: 'Text display',
    all: 'All',
    leaves: 'Leaves',
    extremities: 'Extremities',
    linkLayout: 'Link layout',
    bezier: 'Bezier',
    orthogonal: 'Orthogonal',
    available: 'Available',
    multiSelected: 'Selected',
    moveAll: 'Move all',
    datepicker: {
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
      placeholder: {
        date: 'Select date',
        dateRange: 'Select date range',
        duration: 'Duration time',
        time: 'Time'
      }
    },
    cron: {
      Seconds: {
        name: 'Seconds',
        every: 'Every second',
        interval: ['Every', 'second(s) starting at second'],
        specific: 'Specific second (choose one or many)',
        cycle: ['Every second between second', 'and second']
      },
      Minutes: {
        name: 'Minutes',
        every: 'Every minute',
        interval: ['Every', 'minute(s) starting at minute'],
        specific: 'Specific minute (choose one or many)',
        cycle: ['Every minute between minute', 'and minute']
      },
      Hours: {
        name: 'Hours',
        every: 'Every hour',
        interval: ['Every', 'hour(s) starting at hour'],
        specific: 'Specific hour (choose one or many)',
        cycle: ['Every hour between hour', 'and hour']
      },
      Day: {
        name: 'Day',
        every: 'Every day',
        intervalWeek: ['Every', 'day(s) starting on'],
        intervalDay: ['Every', 'day(s) starting at the', 'of the month'],
        specificWeek: 'Specific day of week (choose one or many)',
        specificDay: 'Specific day of month (choose one or many)',
        lastDay: 'On the last day of the month',
        lastWeekday: 'On the last weekday of the month',
        lastWeek: ['On the last', ' of the month'],
        beforeEndMonth: ['day(s) before the end of the month'],
        nearestWeekday: ['Nearest weekday (Monday to Friday) to the', 'of the month'],
        someWeekday: ['On the', 'of the month']
      },
      Week: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      Month: {
        name: 'Month',
        every: 'Every month',
        interval: ['Every', 'month(s) starting in'],
        specific: 'Specific month (choose one or many)',
        cycle: ['Every month between', 'and']
      },
      Year: {
        name: 'Year',
        every: 'Any year',
        interval: ['Every', 'year(s) starting in'],
        specific: 'Specific year (choose one or many)',
        cycle: ['Every year between', 'and']
      }
    },
    formBuilder: {
      group: 'Questions group',
      typeText: 'Text',
      typeDomain: 'Answers domain',
      typeDate: 'Date',
      dropItemsHere: 'Drop items here...',
      currentLanguage: 'Language',
      emptyName: 'empty text field',
      translations: 'Translations of',
      active: 'Active',
      inactive: 'Inactive',
      read: 'Read-only field',
      create: 'Editable when creating',
      update: 'Editable when creating/modifying',
      required: 'Required',
      optional: 'Optional',
      responsesNumber: 'Responses number',
      responseSelection: 'Response selection',
      available: 'Inactive',
      selected: 'Active',
      moveAll: 'Move all',
      preselected: 'Default',
      selectable: 'Selectable',
      save: 'SAVE and exit',
      saveAndStay: 'SAVE',
      saveResults: 'Operation results',
      saveResultsOk: 'The form questions have been saved successfully.',
      saveResultsKo: 'There is an error saving the data:',
      errorUnknownId: 'Unknown',
      errorUnknownText: 'Contacte with the system administrator',
      conditional: 'conditional',
      notConditional: 'not conditional',
      visibleWith: 'Visible with',
      allOptionValues: 'All options'
    },
    segmentBuilder: {
      group: 'Conditions group',
      typeText: 'Text',
      typeDomain: 'Answers domain',
      typeDate: 'Date',
      typeNumber: 'Number',
      dropItemsHere: 'Drop items here...',
      active: 'Active',
      inactive: 'Inactive',
      conditionsGroupName: 'conditions group description...',
      and: 'and',
      or: 'or',
      minus: 'minus',
      operation: 'Operation',
      conditionRequired: 'this condition is required.',
      someConditionGroupRequired: 'SOME condition group is required.',
      responseSelection: 'Values',
      textSelection: 'Text',
      numberSelection: 'Number',
      dateSelection: 'Date',
      diffDays: 'Number of days before (-) / after',
      available: 'Available',
      moveAll: 'Move all',
      selected: 'Selected',
      from: 'from',
      to: 'to',
      opDomainEqualName: 'Exactly equal',
      opDomainEqualDesc: 'Has exactly the same values.',
      opDomainContainsAllName: 'Contains All',
      opDomainContainsAllDesc: 'Contains all the selected values.',
      opDomainContainsSomeName: 'Contains Some',
      opDomainContainsSomeDesc: 'Contains at least one of the selected values.',
      opDomainNotContainsName: 'Contains None',
      opDomainNotContainsDesc: 'Contains none of the selected values.',
      opDomainInformedName: 'Populated',
      opDomainInformedDesc: 'The field is populated with any value.',
      opDomainNotInformedSomeName: 'Not Populated',
      opDomainNotInformedSomeDesc: 'The field is not populated with any value (null).',
      opTextEqualName: 'Equal',
      opTextEqualDesc: 'Text exactly equal.',
      opTextContainsName: 'Contains',
      opTextContainsDesc: 'Contains the text (\'*apple*\').',
      opTextStartsWithName: 'Starts with',
      opTextStartsWithDesc: 'Starts with the text (\'apple*\').',
      opTextEndsWithName: 'Ends with',
      opTextEndsWithDesc: 'Ends with the text (\'*apple\').',
      opTextNotEqualName: 'Not equal',
      opTextNotEqualDesc: 'Text is different.',
      opTextNotContainsName: 'Does not contain',
      opTextNotContainsDesc: 'Text does not contain the specified value.',
      opTextOnListName: 'On the list',
      opTextOnListDesc: 'On the text list (separated by \'|\')',
      opTextOffListName: 'Off the list',
      opTextOffListDesc: 'Off the text list (separated by \'|\')',
      opTextInformedName: 'Informed',
      opTextInformedDesc: 'Field is populated with any value.',
      opTextNotInformedSomeName: 'Not informed',
      opTextNotInformedSomeDesc: 'Field is not populated with any value (null).',
      opNumberEqualName: 'Equal',
      opNumberEqualDesc: 'Equal number.',
      opNumberNotEqualName: 'Different',
      opNumberNotEqualDesc: 'Different number.',
      opNumberBetweenName: 'Between',
      opNumberBetweenDesc: 'Number within the value range.',
      opNumberNotBetweenName: 'Not between',
      opNumberNotBetweenDesc: 'Number outside the value range.',
      opNumberBiggerName: 'Greater than',
      opNumberBiggerDesc: 'Greater number.',
      opNumberBiggerOrEqualName: 'Greater or equal',
      opNumberBiggerOrEqualDesc: 'Number greater than or equal to.',
      opNumberLessName: 'Less than',
      opNumberLessDesc: 'Smaller number.',
      opNumberLessOrEqualName: 'Less or equal',
      opNumberLessOrEqualDesc: 'Number less than or equal to.',
      opNumberOnListName: 'On the list',
      opNumberOnListDesc: 'On the numbers list (separated by blanks)',
      opNumberOffListName: 'Off the list',
      opNumberOffListDesc: 'Off the numbers list (separated by blanks)',
      opNumberInformedName: 'Informed',
      opNumberInformedDesc: 'Field is populated with any value.',
      opNumberNotInformedSomeName: 'Not informed',
      opNumberNotInformedSomeDesc: 'Field is not populated with any value (null).',
      opDateEqualName: 'Equal',
      opDateEqualDesc: 'Equal date.',
      opDateNotEqualName: 'Different',
      opDateNotEqualDesc: 'Different date.',
      opDateBetweenName: 'Between',
      opDateBetweenDesc: 'Date within the range of values.',
      opDateNotBetweenName: 'Not between',
      opDateNotBetweenDesc: 'Date outside the range of values.',
      opDateBiggerName: 'Greater than',
      opDateBiggerDesc: 'Later date.',
      opDateBiggerOrEqualName: 'Greater or equal',
      opDateBiggerOrEqualDesc: 'Date later than or equal to.',
      opDateLessName: 'Less than',
      opDateLessDesc: 'Earlier date.',
      opDateLessOrEqualName: 'Less or equal',
      opDateLessOrEqualDesc: 'Date earlier than or equal to.',
      opDateYearDayName: 'Day of the year',
      opDateYearDayDesc: 'With the same day and month of every year',
      opDateYearDayTodayName: 'Today of all years',
      opDateYearDayTodayDesc: 'Like today of every year',
      opDateTodayName: 'Today',
      opDateTodayDesc: 'Like today',
      opDateWeekDaysName: 'Week days',
      opDateWeekDaysDesc: 'On the selected week days',
      weekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      opDateMonthDaysName: 'Month days',
      opDateMonthDaysDesc: 'On the selected month days',
      opDateYearMonthsName: 'Months',
      opDateYearMonthsDesc: 'On the selected months',
      days: 'days',
      daysLabel: 'Days',
      months: 'Months',
      opDateInformedName: 'Informed',
      opDateInformedDesc: 'Field is populated with any value.',
      opDateNotInformedSomeName: 'Not informed',
      opDateNotInformedSomeDesc: 'Field is not populated with any value (null).',
      saveAndStay: 'SAVE',
      saveResults: 'Operation results',
      saveResultsOk: 'The segment values have been saved successfully.',
      saveResultsKo: 'There is an error saving the data:',
      totalRows: 'Results:',
      totalQuestionItemRows: 'Results of this filter:',
      totalGroupRows: 'Results of this group:',
      genericFilters: 'Generic filters',
      conditionsOf: 'Conditions of',
      chatTitle: 'AI Assistant',
      chatSummaryIntro: 'Current segment conditions:',
      chatNoConditions: 'The segment has no conditions yet.',
      chatEmptyDesc: 'Describe in natural language the conditions you want to add or modify in the segment.',
      chatEmptyExample: '"Customers with more than 2 purchases in the last 30 days living in Madrid"',
      chatPlaceholder: 'Describe the conditions...',
      chatError: 'Error connecting to the assistant.',
      chatErrorConditions: 'Could not process the conditions. Please try again.'
    }
  }
}

export default languages
